export const sidebarSideOptions = {
  RIGHT: 'right',
  LEFT: 'left'
}
